import styled from '@styled';
import { CSSObject } from 'styled-components';
import { tabletPortrait } from '../global.styles';

interface StyledFlexDivProps {
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'unset';
  flexwrap?: 'wrap' | 'nowrap';
  gap?: CSSObject['gap'];
  margin?: CSSObject['margin'];
  width?: CSSObject['width'];
  maxWidth?: string;
  borderBottom?: string;
  borderLeft?: string;
  borderRight?: string;
  border?: string;
  padding?: string;
  borderRadius?: string;
  background?: CSSObject['background'];
  backgroundColor?: string;
  backgroundImage?: string;
  position?: string;
  height?: string;
  boxShadow?: string;
  cursor?: string;

  mobileprops?: {
    display?: string;
    direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
    justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
    alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch';
    flexwrap?: 'wrap' | 'nowrap';
    gap?: CSSObject['gap'];
    margin?: CSSObject['margin'];
    padding?: string;
    width?: CSSObject['width'];
    height?: string;
    maxWidth?: string;
    borderRight?: string;
  };
}

export const StyledFlexDiv = styled('div').withConfig({
  shouldForwardProp: (prop) =>
    ![
      'justifyContent',
      'alignItems',
      'maxWidth',
      'borderBottom',
      'borderLeft',
      'borderRight',
      'borderRadius',
      'backgroundColor',
      'backgroundImage',
      'background',
      'boxShadow',
    ].includes(prop),
})<StyledFlexDivProps>`
  display: flex;
  cursor: ${(props) => props.cursor || 'initial'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  align-items: ${(props) => props.alignItems || 'flex-start'};
  flex-wrap: ${(props) => props.flexwrap || 'nowrap'};
  gap: ${(props) => props.gap || '0'};
  margin: ${(props) => props['data-margin'] || '0'};
  padding: ${(props) => props.padding || '0'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '100%'};
  position: ${(props) => props.position || 'static'};
  border-bottom: ${(props) => props.borderBottom || 'none'};
  border-left: ${(props) => props.borderLeft || 'none'};
  border-right: ${(props) => props.borderRight || 'none'};
  max-width: ${(props) => props.maxWidth || '100%'};
  min-width: ${(props) => props.minWidth || undefined};
  min-height: ${(props) => props.minHeight || undefined};
  max-height: ${(props) => props.maxHeight || undefined};
  border-radius: ${(props) => props.borderRadius || '0'};
  background-color: ${(props) => props.backgroundColor || 'transparent'};
  background-image: ${(props) => (props.backgroundImage ? `url(${props.backgroundImage})` : 'none')};
  background: ${(props) => (props.background ? props.background : undefined)};
  box-shadow: ${(props) => props.boxShadow || 'none'};

  ${tabletPortrait} {
    display: ${(props) => props.mobileprops?.display || 'flex'};
    flex-direction: ${(props) => props.mobileprops?.direction || 'column'};
    justify-content: ${(props) => props.mobileprops?.justifyContent || 'flex-start'};
    align-items: ${(props) => props.mobileprops?.alignItems || 'flex-start'};
    flex-wrap: ${(props) => props.mobileprops?.flexwrap || 'wrap'};
    gap: ${(props) => props.mobileprops?.gap || '0'};
    margin: ${(props) => props.mobileprops?.margin || '0'};
    padding: ${(props) => props.mobileprops?.padding || '0'};
    width: ${(props) => props.mobileprops?.width || '100%'};
    height: ${(props) => props.mobileprops?.height || props.height || '100%'};
    max-width: ${(props) => props.mobileprops?.maxWidth || props.maxWidth || '100%'};
    border-right: ${(props) => props.mobileprops?.borderRight || props.borderRight || 'none'};
  }
`;
